
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class AppSelect extends Vue {
  public get attributes(): Record<string, unknown> {
    return {
      ...this.$attrs,
      dense: true,
      outlined: true,
      hideDetails: "auto",
    };
  }
}
